import router from '@/router'

let messages: Record<string, string> = {}

/**
 * messages.json をロード
 * 読み込めなければ ErrorPage に遷移
 */
export async function loadMessages(): Promise<void> {
  if (Object.keys(messages).length > 0) return

  const response = await fetch('/messages.json')
  if (!response.ok) {
    router.push({ name: 'ErrorPage' })
    return
  }
  messages = await response.json()
}

export function getMessages(): Record<string, string> {
  return messages
}

/**
 * 指定された messageId に対応するメッセージテンプレートを取得し、
 * プレースホルダを置換して改行区切りで結合した文字列を返す。
 *
 * プレースホルダの置換ルール:
 * - `:{placeholder}` → values[placeholder] の値に置換（存在しない場合は元の文字列を維持）
 * - `{field}` → 引数 fieldName に置換
 *
 * @param messageId メッセージID（IDまたはIDの配列）
 * @param fieldName {field} プレースホルダに適用するフィールド名
 * @param values その他のプレースホルダに対応する値のマップ（例: { value: 100 }）
 * @returns 置換後のメッセージを改行で結合した文字列
 *
 * 使用例:
 * getFieldMessage('max', 'コメント', { value: 100 })
 * → "コメントは 100 文字以内にしてください"
 */
export function getFieldMessage(
  messageId: string | string[],
  fieldName: string = '',
  values: Record<string, string | number> = {},
): string {
  const ids = Array.isArray(messageId) ? messageId : [messageId]
  if (!ids || ids.length === 0) return ''

  return ids
    .map((key) => {
      let template = messages[key] || key

      // :{placeholder} を置換
      template = template.replace(/:\{(\w+)\}/g, (match, k) => {
        if (k === 'field') return fieldName
        return values[k] !== undefined ? String(values[k]) : match
      })

      // {field} を置換
      template = template.replace(/\{field\}/g, fieldName)

      return template
    })
    .join('\n')
}
